/* eslint-disable no-console */
import Joi from 'joi';
import api from '../api';
import * as Types from '../types';

/**
 * Get all resources with their leave and remote configuration
 *
 * @async
 * @return {Promise<Array<Types.ResourceConfiguration>>} Response from API under Axios instance
 */
export const getResourcesStaffList = async () => {
  const result = await api.get('/resources');

  try {
    const dataSchema = Joi.array().items(Types.resourceConfigurationSchema);
    await dataSchema.validateAsync(result?.data?.data);
  } catch (error) {
    console.error(error);
    throw Error(`getResourcesStaffList result do not validate resourceConfigurationSchema : ${error}`);
  }

  return result.data.data;
};

/**
 * Get a resource with their leave and remote configuration
 *
 * @async
 * @param {Object} queryParams
 * @param {string} queryParams.resourceId
 * @return {Promise<Types.ResourceConfiguration>} Response from API under Axios instance
 */
export const getResourceConfiguration = async (queryParams) => {
  const result = await api.get(
    `/resources/${queryParams.resourceId}`,
  );

  try {
    await Types.resourceConfigurationSchema.validateAsync(result.data);
  } catch (error) {
    console.error(error);
    throw Error(`getResourceConfiguration result do not validate resourceConfigurationSchema : ${error}`);
  }

  return result.data;
};

/**
 * Update leave and remote configuration of a resource
 *
 * @async
 * @param {string} resourceId
 * @param {Object} data
 * @param {number} data.version
 * @param {number} data.maxRemoteWorkingPostsPerWeek
 * @param {boolean} data.isSubjectToRemoteWorkingRotationRule
 * @param {boolean} data.canPostCompensatoryTimeLeave
 * @param {Array.<Object>} data.partTimeSchedule
 * @return {Promise} Response from API under Axios instance
 */
export const patchResourceConfiguration = (resourceId, data) => api.patch(
  `/resources/${resourceId}`,
  data,
);

/**
 * Get all resources with their user informations
 *
 * @async
 * @return {Promise<Array<Types.Resource>>} Response from API under Axios instance
 */
export const getResourcesList = async () => {
  const result = await api.get('/resources', {
    baseURL: import.meta.env.VITE_RESOURCES_URL,
  });

  try {
    const dataSchema = Joi.array().items(Types.resourceSchema);
    await dataSchema.validateAsync(result?.data?.data);
  } catch (error) {
    console.error(error);
    throw Error(`getResourcesList result do not validate resourceSchema : ${error}`);
  }

  return result.data.data;
};

/**
 * Get connected user associated resource
 *
 * @async
 * @return {Promise<Types.Resource>} Response from API under Axios instance
 */
export const getOwnResource = async () => {
  const result = await api.get('/resources/me', {
    baseURL: import.meta.env.VITE_RESOURCES_URL,
  });

  try {
    await Types.resourceSchema.validateAsync(result.data.data);
  } catch (error) {
    console.error(error);
    throw Error(`getOwnResource result do not validate resourceSchema : ${error}`);
  }

  return result.data;
};
